import { render, staticRenderFns } from "./user-progress.vue?vue&type=template&id=2eaada46&"
import script from "./user-progress.vue?vue&type=script&lang=js&"
export * from "./user-progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports